// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_j2-0";